import isEqual from "lodash.isequal"
import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

import { preferencesSuccess } from "../User/redux/user.actions"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getPerksAdminRequest: ["payload"],
  getPerksAdminSuccess: ["payload"],
  getPerksAdminFailure: ["payload"],

  getPerksAdminFilterOptionsRequest: ["payload"],
  getPerksAdminFilterOptionsSuccess: ["payload"],
  getPerksAdminFilterOptionsFailure: ["payload"],

  createPerkAdminRequest: ["payload"],
  createPerkAdminSuccess: ["payload"],
  createPerkAdminFailure: ["payload"],

  updatePerkAdminRequest: ["payload"],
  updatePerkAdminSuccess: ["payload"],
  updatePerkAdminFailure: ["payload"],

  deletePerkAdminRequest: ["payload"],
  deletePerkAdminSuccess: ["payload"],
  deletePerkAdminFailure: ["payload"],

  togglePerkVisibilityRequest: ["payload"],
  togglePerkVisibilitySuccess: ["payload"],
  togglePerkVisibilityFailure: ["payload"],

  getPerksManageOrderRequest: ["payload"],
  getPerksManageOrderSuccess: ["payload"],
  getPerksManageOrderFailure: ["payload"],

  reorderPerksRequest: ["payload"],
  reorderPerksSuccess: ["payload"],
  reorderPerksFailure: ["payload"],

  savePerkCommentRequest: ["payload"],
  savePerkCommentSuccess: ["payload"],
  savePerkCommentFailure: ["payload"],

  deletePerkCommentRequest: ["payload"],
  deletePerkCommentSuccess: ["payload"],
  deletePerkCommentFailure: ["payload"],

  perksAdminSetProp: ["key", "value"],
  clearPerksAdminFilters: null,
  resetPerksAdminSaveResult: null,

  logout: null
})

export const PerksAdminTypes = Types
export default Creators

/* ------------- Columns ------------- */

const columns = [
  { field_id: "is_visible", label: "Visibility", active: true },
  { field_id: "created", label: "Created", active: true },
  { field_id: "partner_name", label: "Partner name", active: true },
  { field_id: "partner_website", label: "Partner website", active: true },
  { field_id: "offer_details", label: "Offer details", active: true },
  { field_id: "description", label: "Description", active: true },
  { field_id: "url", label: "URL", active: true },
  { field_id: "promocode", label: "Promocode", active: true },
  { field_id: "comment", label: "Comments", active: true }
]

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  result: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },

  defaultColumns: [...columns],
  columns: [...columns],

  filtersLastUpd: null,
  filters: {
    partner_name: "all",
    created: null
  },
  visibleFilters: { partner_name: true, created: true },

  saveFetching: false,
  saveResult: null,

  manageOrderFetching: false,
  manageOrderList: [],

  filterOptions: {
    partner_name: []
  }
})

/* ------------- Selectors ------------- */
export const selectAreFiltersDefault = (state) =>
  isEqual(state.perksAdmin.filters, INITIAL_STATE.filters)

/* ------------- Reducers ------------- */

const getPerksAdminRequest = (state) => state.merge({ fetching: true })
const getPerksAdminSuccess = (state, { payload: result }) =>
  state.merge({ fetching: false, result })
const getPerksAdminFailure = (state) => state.merge({ fetching: false })

const getPerksAdminFilterOptionsSuccess = (state, { payload }) => {
  const partner_name = Array.isArray(payload?.partner_name)
    ? payload.partner_name?.map((p) => p?.label)
    : []

  return state.merge({ filterOptions: { partner_name } })
}

const getPerksAdminFilterOptionsFailure = (state) => {
  const names = (state?.result?.results || []).map((r) => r.partner_name).filter(Boolean)

  return state.merge({
    filterOptions: { partner_name: Array.from(new Set(names)) }
  })
}

const createPerkAdminRequest = (state) => state.merge({ saveFetching: true })
const createPerkAdminSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "perk_create" })
const createPerkAdminFailure = (state) => state.merge({ saveFetching: false })

const updatePerkAdminRequest = (state) => state.merge({ saveFetching: true })
const updatePerkAdminSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "perk_update" })
const updatePerkAdminFailure = (state) => state.merge({ saveFetching: false })

const deletePerkAdminRequest = (state) => state.merge({ saveFetching: true })
const deletePerkAdminSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "perk_delete" })
const deletePerkAdminFailure = (state) => state.merge({ saveFetching: false })

const togglePerkVisibilityRequest = (state) => state.merge({ saveFetching: true })
const togglePerkVisibilitySuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "perk_visibility" })
const togglePerkVisibilityFailure = (state) => state.merge({ saveFetching: false })

const getPerksManageOrderRequest = (state) => state.merge({ manageOrderFetching: true })
const getPerksManageOrderSuccess = (state, { payload }) => {
  const list = Array.isArray(payload) ? payload : payload?.results || []
  return state.merge({ manageOrderFetching: false, manageOrderList: list })
}
const getPerksManageOrderFailure = (state) => state.merge({ manageOrderFetching: false })

const reorderPerksRequest = (state) => state.merge({ saveFetching: true })
const reorderPerksSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "perk_reorder" })
const reorderPerksFailure = (state) => state.merge({ saveFetching: false })

const savePerkCommentRequest = (state) => state.merge({ saveFetching: true })
const savePerkCommentSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "perk_comment" })
const savePerkCommentFailure = (state) => state.merge({ saveFetching: false })

const deletePerkCommentRequest = (state) => state.merge({ saveFetching: true })
const deletePerkCommentSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "perk_comment_delete" })
const deletePerkCommentFailure = (state) => state.merge({ saveFetching: false })

export const perksAdminSetProp = (state, { key, value }) => {
  const obj = {}
  if (key === "filters") {
    obj.filtersLastUpd = new Date().getTime()
    obj.filters = { ...state.filters, ...value }
  } else if (key === "visibleFilters") {
    obj.visibleFilters = { ...state.visibleFilters, ...value }
  } else {
    obj[key] = value
  }
  return state.merge(obj)
}

const clearPerksAdminFilters = (state) => state.merge({ filters: INITIAL_STATE.filters })

const resetPerksAdminSaveResult = (state) => state.merge({ saveResult: null })

const logout = () => INITIAL_STATE

// Bump when the shape of the saved `{ version, filters, columns, visibleFilters }` payload changes.
export const PERKS_ADMIN_PREFERENCES_VERSION = 1

const applyPreferences = (state, { payload }) => {
  const preference = payload?.["perks-admin"]?.data
  if (!preference || preference.version !== PERKS_ADMIN_PREFERENCES_VERSION) return state
  if (!preference.filters || !preference.columns || !preference.visibleFilters) return state

  return state.merge({
    filters: preference.filters,
    columns: preference.columns,
    visibleFilters: preference.visibleFilters
  })
}

/* ------------- Hookup ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_PERKS_ADMIN_REQUEST]: getPerksAdminRequest,
  [Types.GET_PERKS_ADMIN_SUCCESS]: getPerksAdminSuccess,
  [Types.GET_PERKS_ADMIN_FAILURE]: getPerksAdminFailure,

  [Types.GET_PERKS_ADMIN_FILTER_OPTIONS_SUCCESS]: getPerksAdminFilterOptionsSuccess,
  [Types.GET_PERKS_ADMIN_FILTER_OPTIONS_FAILURE]: getPerksAdminFilterOptionsFailure,

  [Types.CREATE_PERK_ADMIN_REQUEST]: createPerkAdminRequest,
  [Types.CREATE_PERK_ADMIN_SUCCESS]: createPerkAdminSuccess,
  [Types.CREATE_PERK_ADMIN_FAILURE]: createPerkAdminFailure,

  [Types.UPDATE_PERK_ADMIN_REQUEST]: updatePerkAdminRequest,
  [Types.UPDATE_PERK_ADMIN_SUCCESS]: updatePerkAdminSuccess,
  [Types.UPDATE_PERK_ADMIN_FAILURE]: updatePerkAdminFailure,

  [Types.DELETE_PERK_ADMIN_REQUEST]: deletePerkAdminRequest,
  [Types.DELETE_PERK_ADMIN_SUCCESS]: deletePerkAdminSuccess,
  [Types.DELETE_PERK_ADMIN_FAILURE]: deletePerkAdminFailure,

  [Types.TOGGLE_PERK_VISIBILITY_REQUEST]: togglePerkVisibilityRequest,
  [Types.TOGGLE_PERK_VISIBILITY_SUCCESS]: togglePerkVisibilitySuccess,
  [Types.TOGGLE_PERK_VISIBILITY_FAILURE]: togglePerkVisibilityFailure,

  [Types.GET_PERKS_MANAGE_ORDER_REQUEST]: getPerksManageOrderRequest,
  [Types.GET_PERKS_MANAGE_ORDER_SUCCESS]: getPerksManageOrderSuccess,
  [Types.GET_PERKS_MANAGE_ORDER_FAILURE]: getPerksManageOrderFailure,

  [Types.REORDER_PERKS_REQUEST]: reorderPerksRequest,
  [Types.REORDER_PERKS_SUCCESS]: reorderPerksSuccess,
  [Types.REORDER_PERKS_FAILURE]: reorderPerksFailure,

  [Types.SAVE_PERK_COMMENT_REQUEST]: savePerkCommentRequest,
  [Types.SAVE_PERK_COMMENT_SUCCESS]: savePerkCommentSuccess,
  [Types.SAVE_PERK_COMMENT_FAILURE]: savePerkCommentFailure,

  [Types.DELETE_PERK_COMMENT_REQUEST]: deletePerkCommentRequest,
  [Types.DELETE_PERK_COMMENT_SUCCESS]: deletePerkCommentSuccess,
  [Types.DELETE_PERK_COMMENT_FAILURE]: deletePerkCommentFailure,

  [Types.PERKS_ADMIN_SET_PROP]: perksAdminSetProp,
  [Types.CLEAR_PERKS_ADMIN_FILTERS]: clearPerksAdminFilters,
  [Types.RESET_PERKS_ADMIN_SAVE_RESULT]: resetPerksAdminSaveResult,

  [Types.LOGOUT]: logout,

  [preferencesSuccess.type]: applyPreferences
})
